<div class="no-permissions-container">
  <div class="no-permissions-content">
    <h1>Access denied</h1>
    <h4>You do not have the permissions required to access this application. Contact your administrator to request access.</h4>
  </div>
</div>
